import {Component, Input} from "@angular/core";
import {AriadnextUserCheck} from "../../../api/entity";

@Component({
    selector: 'tfl-bo-verification-ariadnext-check',
    template: `
        <accordion>
            <accordion-group>
                <accordion-header>
                    <accordion-toggle
                        title="{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.CHECK_ID' | translate }}: {{ check.checkId }} . {{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.SEND_DATE_TIME' | translate }}: {{ check.sendDateTime }}">
                    </accordion-toggle>
                </accordion-header>

                <accordion-content>

                    <div class="row">
                        <div class="col-xs-3">
                            <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.NOTIFICATION_LINK' | translate }}:</b>
                        </div>
                        <div class="col-xs-9">{{ check.notificationLink }}</div>
                    </div>

                    <div class="row">
                        <div class="col-xs-3">
                            <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.SEND_LINK_APPROACH' | translate }}:</b>
                        </div>
                        <div class="col-xs-9">{{ check.sendLinkApproach }}</div>
                    </div>

                    <div class="row">
                        <div class="col-xs-3">
                            <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.STATUS' | translate }}:</b>
                        </div>
                        <div class="col-xs-9">
                            <tfl-bo-ariadnext-status-badge
                                [status]="check.ariadnextStatus"></tfl-bo-ariadnext-status-badge>
                        </div>
                    </div>

                    <div class="row" *ngIf="check.validationErrorReason">
                        <div class="col-xs-3">
                            <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.ERROR_REASON' | translate }}:</b>
                        </div>
                        <div class="col-xs-9">
                            <div class="alert alert-danger fade in verification-error-reason">
                                {{ check.validationErrorReason }}
                            </div>
                        </div>
                    </div>

                </accordion-content>
            </accordion-group>
        </accordion>
    `
})
export class AriadnextCheckVerificationComponent {

    @Input("check") check: AriadnextUserCheck;


}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/ariadnext/result/ariadnext-check.verification.component.ts